import React from 'react';
import { BrowserRouter as Router, Switch, Route, useRouteMatch } from "react-router-dom";
import { Typography } from '@material-ui/core';
import PortfolioCards from "../../components/PortfolioCards";
import { connect } from 'react-redux'
import Portfolio from "../../components/Portfolio";
import Header from './components/Header';
import Transactions from "../../components/Transactions";
import Analytics from "../../components/Analytics";
import Security from "../../components/Security";
import Bottom from "./components/Bottom";
import Hidden from '@material-ui/core/Hidden';
import HorizontalLinearStepper from "../../components/HorizontalLinearStepper";
import CorporateActions from "../../components/CorporateActions";
import MCPTokens from "../../components/MCPTokens";
function MainPage() {

    const { path, url } = useRouteMatch();

    return (
        <Router>
            <Switch>
                <Route path="/welcome" component={HorizontalLinearStepper} exact/>
                <Route>
                    <Header />
                    <Switch>
                        <Route path="/portfolio" component={Portfolio}/>
                        <Route path="/analytics" component={Analytics}/>
                        <Route path="/transactions" component={Transactions}/>
                        <Route path="/portfolios" component={PortfolioCards}/>
                        <Route path="/security/:id" component={Security} />
                        <Route path="/events" component={CorporateActions}/>
                        <Route path="/settings/tokens" component={MCPTokens}/>
                    </Switch>
                    <Hidden mdUp>
                        <Bottom/>
                    </Hidden>
                </Route>
            </Switch>

        </Router>
    );
}

// приклеиваем данные из store
const mapStateToProps = store => {
    console.log(store) // посмотрим, что же у нас в store?
    return {
        user: store.user,
        portfolios: store.portfolio,
    }
}

// в наш компонент App, с помощью connect(mapStateToProps)
export default connect(mapStateToProps)(MainPage)
